import { POINTS_CURRENCY_CODE, US_CURRENCY_CODE } from "@constants/store";

// These queries are getting fired using axios so we dont have to wrap it with gql
// We have passed privateAttributes as false and thats why we need to ensure that in future
//    no user dependent attributes get fetched in this query
export const fetchStoreBasicDetails = `
  query Store($code: String, $number: String, $customDomainRoot: String, $onlyActive: Boolean, $privateAttributes: Boolean, $withTheme: Boolean! = false) {
    store(code: $code, number: $number, customDomainRoot: $customDomainRoot, onlyActive: $onlyActive, privateAttributes: $privateAttributes) {
      id
      accessible
      accessibilityEnabled(customDomainRoot: $customDomainRoot)
      active
      name
      code
      cloneId
      currencyType
      logo
      logoType
      defaultCountryId
      externalId
      feUrl
      customDomainUrl
      theme
      compressedTopBanner
      topBanner
      mobileTopBanner
      seoTitle
      metaDescription
      number
      parentId
      featured
      showMoreFromThisBrand
      showYouMightAlsoLike
      syncedToEs
      displayWarehouseAddress
      isLockerShop: displayWarehouseAddress
      actAsLockerShop
      cacheKey
      shopType
      private
      pointsMigrationAllowed
      enableCeilPrices
      hideBulkPricing
      favicon
      workspaceId
      storeOwners {
        email
      }
      storeDetail {
        allowCorporateBilling
        sendToManyEnabled
        blacklistedCountries
        footerText
        pastelUrl
        longDescription
        thankYouTitle
        thankYouMessage
        featuredMenuHidden
        filterLocation
        hideThankYouMessagePrompts
        hideThankYouMessagePlaceholder
        homepageJson
        productPageJson
        categoryPageJson
        searchIndexed
        hideMenuBar
        allowSendPointsFromStorefront
        navBarTheme
        billingNoteOnSelfOrder
        analytics
        showBookACall
        hideCountryFlags
        billingNoteRequired
        additionalBillingNote
        showCategoryImages
        newRoutesEnabled
      }
      membership {
        whitelabel
        customDomain
      }
      parent {
        code
        number
      }
      brandingTheme @include(if: $withTheme) {
        buttons
        colors
        typography {
          fontFamilies
          fontSizes
        }
      }
      minPrice
      maxPrice
      config {
        type
        currencyCode
        currencyName
        currencyPrefix
        currencySuffix
        programName
        upcharge
        medleyPrices {
          amount
          amountIn
          displayName
          id
        }
        usdMedleyPrices: medleyPrices {
          amount(currency: "${US_CURRENCY_CODE}")
          amountIn(currency: "${US_CURRENCY_CODE}")
          displayName
          id
        }
        stcMedleyPrices: medleyPrices {
          amount(currency: "${POINTS_CURRENCY_CODE}")
          amountIn(currency: "${POINTS_CURRENCY_CODE}")
          displayName
          id
        }
      }
    }
  }
`;
